import { useState } from 'react';
import { useZakeke } from 'zakeke-configurator-react';

const useExposed = () => {
  const { isExplodedMode, hasExplodedMode: hasExploded, setExplodedMode } = useZakeke();
  const [isExploded, setIsExploded] = useState<boolean>(isExplodedMode);

  const toggleExploded = () => {
    setExplodedMode(!isExploded);
    setIsExploded(!isExploded);
  };

  return {
    isExploded,
    hasExploded,
    toggleExploded,
  };
};

export { useExposed as useExploded };
